import { createApp } from 'vue';
import NefToAvifConverter from '../Components/NefToAvifConverter.vue';

const root = document.getElementById('nef-to-avif-converter');
if (root) {
  createApp(NefToAvifConverter).mount('#nef-to-avif-converter');
}
